module.exports = __webpack_public_path__ + "static/headshot-steffan-haas-3x.0e2ea089.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-steffan-haas-3x.jpg
// module id = 538
// module chunks = 152909308826437